import { useState, useEffect, useCallback } from "react";
import { conversationService } from "@/modules/services/conversationService";
import { useEmployeeInfo } from "../employee/useEmployeeInfo";
import { AppError } from "@/lib/utils/errors";

export const useUnreadConversations = () => {
  const { employeeInfo } = useEmployeeInfo();
  const [totalUnreadConversations, setTotalUnreadConversations] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const loadUnreadConversationsCount = useCallback(async () => {
    if (!employeeInfo?.id) return;

    setIsLoading(true);
    try {
      const response = await conversationService.getTotalUnreadConversation(
        employeeInfo.id
      );
      if (response && response.total !== undefined) {
        setTotalUnreadConversations(response.total);
      }
    } catch (err) {
      const appErr = new AppError(err);
      appErr.setAction("useUnreadConversations.loadUnreadConversationsCount");
      appErr.setApiAction("conversationService.getTotalUnreadConversation");
      appErr.logError(
        "src/modules/hooks/conversation/useUnreadConversations.ts[loadUnreadConversationsCount]"
      );
    } finally {
      setIsLoading(false);
    }
  }, [employeeInfo?.id]);

  useEffect(() => {
    if (employeeInfo?.id) {
      loadUnreadConversationsCount();
    }
  }, [employeeInfo?.id, loadUnreadConversationsCount]);

  return {
    totalUnreadConversations,
    isLoading,
    loadUnreadConversationsCount,
  };
};
